import * as Yup from 'yup';
import i18n from '../i18n';

const ShiftFormScheme = Yup.object().shape({
  shiftName: Yup.string()
    .min(2, i18n('validation.short'))
    .max(255, i18n('validation.long'))
    .required(i18n('validation.required')),
  projectName: Yup.string()
    .min(2, i18n('validation.short'))
    .max(255, i18n('validation.long')),
  projectIdentifier: Yup.string(),
  startDate: Yup.string()
    .required(i18n('validation.required')),
  endDate: Yup.string()
    .required(i18n('validation.required')),
  employees: Yup.string(),
  contractor: Yup.string().nullable(),
});

export default ShiftFormScheme;



// WEBPACK FOOTER //
// ./src/forms/ShiftFormScheme.js